import { fetchService } from "@/core/services/fetch-service";
import { IAuthInfo } from "../models/auth-info";

export default class AuthService {
	public getAuthInfo(): Promise<IAuthInfo> {
		return fetchService.get<IAuthInfo>("/Account/AuthInfo");
	}
}

export const authService = new AuthService();